module.exports = __webpack_public_path__ + "static/media/logo.678d784a.svg";